/**
 * Short file-name suffix for the filters behind an export, so two downloads of
 * the same card with different filters never look alike:
 *   { specialty: "Cardiology", platform: "app" } → "_platform-app_specialty-Cardiology"
 * Keys are sorted; values are reduced to file-name-safe characters and capped.
 */
export function filterSlug(filters = {}) {
  const parts = Object.entries(filters)
    .filter(([, v]) => v)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([k, v]) => `${k}-${String(v).replace(/[^A-Za-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 24)}`);
  return parts.length ? `_${parts.join("_")}` : "";
}
